import { z } from 'zod';

import { MAX_WEIGHT_LBS, MIN_WEIGHT_LBS } from '../constants';

// All five fields are required (mirrors Sparta's CreateProfile validation).
// Selects yield string values ('5', '10', 'M', 'asian'); weight is typed text.
// Height feet/inches are kept as strings here and converted to total inches in
// mapFormValuesToDraft. `inches: '0'` is a valid selection, so the required
// check is "non-empty string", not a truthiness check.
export const createProfileSchema = z.object({
  feet: z.string().min(1, 'Required'),
  inches: z.string().min(1, 'Required'),
  weight: z
    .string()
    .min(1, 'Required')
    .refine((value) => {
      const n = Number(value);
      return Number.isFinite(n) && n >= MIN_WEIGHT_LBS && n <= MAX_WEIGHT_LBS;
    }, 'Enter a valid weight'),
  gender: z.string().min(1, 'Required'),
  ethnicity: z.string().min(1, 'Required'),
});

export type CreateProfileFormValues = z.infer<typeof createProfileSchema>;
